import React, { useEffect, useState, useMemo } from "react";
import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";
import facebook_icon from "../../../../assets/utils/images/sns/facebook.png";
import line_icon from "../../../../assets/utils/images/sns/line.png";
import youtube_icon from "../../../../assets/utils/images/sns/youtube.png";
import twitter_icon from "../../../../assets/utils/images/sns/twitter-new.png";
import tiktok_icon from "../../../../assets/utils/images/sns/tiktok.png";
import instagram_icon from "../../../../assets/utils/images/sns/instagram.png";
import * as Ionicons from "react-icons/io";
import EditInfoInput from "../../ProfileOrg/Components/EditInfoInput";
import { Multiselect } from "react-widgets";
import { useMutation, useQuery } from "@apollo/client";
import {
  CHECK_USER_STATUS,
  QUERY_GET_ALL_COUNTRIES,
  QUERY_GET_ALL_SDGS,
  QUERY_GET_FOREIGN_BRANCH_COUNTRIES,
  QUERY_GET_SALE_SCALE,
  QUERY_ORG_SUPPORTER,
  UPDATE_M2M_SUPPORTER,
  UPDATE_M2M_SUPPORTER_OVERSEAS_BRANCH,
  UPDATE_M2M_SUPPORTER_SDGS,
  UPDATE_SUPPORTER,
} from "../../../../queries";
import { Button, Card, Col, Input, Row } from "reactstrap";
import ActivityField from "../../ProfileOrg/Components/ActivityField";
import { useUserEmail } from "../../../../Layout/AppMain/LoginStatusContext";

const TabOrganizationOverview = ({
  publicView = false,
  passedOrgSupporterRaw = null,
}) => {
  const [editState, setEditState] = useState({
    incorporationDate: false,
    prefecture: false,
    city: false,
    phoneNumber: false,
    representativeName: false,
    industry: false,
    scaleLevel: false,
    stuffNumber: false,
    foreignBranch: false,
    sdgs: false,
    homepageUrl: false,
    csrUrl: false,
    sns: false,
  });
  const [facebook, setFacebook] = useState("");
  const [line, setLine] = useState("");
  const [instagram, setInstagram] = useState("");
  const [youtube, setYoutube] = useState("");
  const [twitter, setTwitter] = useState("");
  const [tiktok, setTiktok] = useState("");
  const [selectedOverseasBranch, setSelectedOverseasBranch] = useState([]);
  const [selectedSdgs, setSelectedSdgs] = useState([]);
  const [selectedSaleScale, setSelectedSaleScale] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState("");

  const allSaleScale = useQuery(QUERY_GET_SALE_SCALE);
  const foreignBranchCountries = useQuery(QUERY_GET_ALL_COUNTRIES);
  const orgSupporterRaw = useQuery(QUERY_ORG_SUPPORTER);
  const orgSupporter = useMemo(() => {
    return publicView && passedOrgSupporterRaw
      ? {
          data: {
            allSupporters: {
              edges: [
                {
                  node: {
                    ...passedOrgSupporterRaw?.data?.getSpecificSupporter,
                  },
                },
              ],
            },
          },
        }
      : orgSupporterRaw;
  }, [publicView, passedOrgSupporterRaw, orgSupporterRaw]);

  const { data: checkUserStatus } = useQuery(CHECK_USER_STATUS, {
    variables: {
      email: useUserEmail(),
    },
  });

  const canEdit =
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "can_edit" ||
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "CAN_EDIT";

  const sdgs = useQuery(QUERY_GET_ALL_SDGS);
  const [updateSupporter] = useMutation(UPDATE_SUPPORTER, {
    onCompleted: () => {
      setEditState({
        incorporationDate: false,
        prefecture: false,
        city: false,
        phoneNumber: false,
        representativeName: false,
        industry: false,
        scaleLevel: false,
        stuffNumber: false,
        foreignBranch: false,
        sdgs: false,
        homepageUrl: false,
        csrUrl: false,
        sns: false,
      });
      orgSupporter.refetch();
    },
  });
  const [updateM2m] = useMutation(UPDATE_M2M_SUPPORTER_OVERSEAS_BRANCH, {
    onCompleted: () => {
      setEditState({
        incorporationDate: false,
        prefecture: false,
        city: false,
        phoneNumber: false,
        representativeName: false,
        industry: false,
        scaleLevel: false,
        stuffNumber: false,
        foreignBranch: false,
        sdgs: false,
        homepageUrl: false,
        csrUrl: false,
        sns: false,
      });
      orgSupporter.refetch();
    },
  });

  const [updateSdges] = useMutation(UPDATE_M2M_SUPPORTER_SDGS, {
    onCompleted: () => {
      setEditState({
        incorporationDate: false,
        prefecture: false,
        city: false,
        phoneNumber: false,
        representativeName: false,
        industry: false,
        scaleLevel: false,
        stuffNumber: false,
        foreignBranch: false,
        sdgs: false,
        homepageUrl: false,
        csrUrl: false,
        sns: false,
      });
      orgSupporter.refetch();
    },
  });

  const SyncIcon = Ionicons["IoIosSync"];
  const CloseIcon = Ionicons["IoMdClose"];

  const iconStyle = {
    width: "22px",
    height: "22px",
    borderRadius: "200px",
    marginRight: "3px",
  };
  const iconStyleDisabled = {
    opacity: "0.4",
    width: "22px",
    height: "22px",
    borderRadius: "200px",
    marginRight: "3px",
  };

  async function updatedSupporter(mutationValiables) {
    try {
      await updateSupporter({
        variables: mutationValiables,
      });
    } catch (err) {
      alert("正しい入力形式で入力してください");
    }
  }

  useEffect(() => {
    if (!orgSupporter.data) return;
    setFacebook(orgSupporter?.data?.allSupporters?.edges[0]?.node?.facebook);
    setLine(orgSupporter?.data?.allSupporters?.edges[0]?.node?.line);
    setInstagram(orgSupporter?.data?.allSupporters?.edges[0]?.node?.instagram);
    setYoutube(orgSupporter?.data?.allSupporters?.edges[0]?.node?.youtube);
    setTwitter(orgSupporter?.data?.allSupporters?.edges[0]?.node?.twitter);
    setTiktok(orgSupporter?.data?.allSupporters?.edges[0]?.node?.tiktok);
    setSelectedOverseasBranch(
      orgSupporter?.data?.allSupporters?.edges[0]?.node?.overseasBranch?.edges?.map(
        (branch) => {
          return {
            id: branch?.node?.id,
            nameJp: branch?.node?.nameJp,
          };
        }
      )
    );
    setSelectedSdgs(
      orgSupporter?.data?.allSupporters?.edges[0]?.node?.focusedSdges?.edges
    );
    setSelectedSaleScale(
      orgSupporter?.data?.allSupporters?.edges[0]?.node?.saleScale?.scaleLevel
    );
    setSelectedIndustry(
      orgSupporter?.data?.allSupporters?.edges[0]?.node?.industry
    );
  }, [orgSupporter]);

  useEffect(() => {
    if (!allSaleScale.data) return;
  }, [allSaleScale]);

  return (
    <Card className="mb-2  org_contentarea">
      <div className="org_subtitle_sec">
        <h4 className="org_subtitle">組織情報</h4>
      </div>
      {orgSupporter?.loading || (publicView && !passedOrgSupporterRaw.data) ? (
        <div className="loading__wrapper">
          <img style={{ width: "80px", margin: "auto" }} src={animetionLogo} />
        </div>
      ) : (
        <div className="org_item">
          <Row>
            <Col sm="12" lg="6">
              <table className="org_item_table_supporter">
                <tbody>
                  <tr>
                    <th>設立</th>
                    {editState?.incorporationDate ? (
                      <div className="flex-ai-center">
                        <EditInfoInput
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"incorporationDate"}
                          updatedOrgProfile={updatedSupporter}
                          value={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.incorporationDate
                          }
                          mutationVariables={{}}
                          mutatinValiablesKey="incorporationDate"
                        />
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.incorporationDate !== ""
                          ? orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.incorporationDate
                          : "-"}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                incorporationDate: !editState.incorporationDate,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>本社住所（都道府県）</th>
                    {editState?.prefecture ? (
                      <div className="flex-ai-center">
                        <EditInfoInput
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"prefecture"}
                          updatedOrgProfile={updatedSupporter}
                          value={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.prefecture
                          }
                          mutationVariables={{}}
                          mutatinValiablesKey="prefecture"
                        />
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.prefecture !== ""
                          ? orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.prefecture
                          : "-"}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                prefecture: !editState.prefecture,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>本社住所（市区町村）</th>
                    {editState?.city ? (
                      <div className="flex-ai-center">
                        <EditInfoInput
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"city"}
                          updatedOrgProfile={updatedSupporter}
                          value={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.city
                          }
                          mutationVariables={{}}
                          mutatinValiablesKey="city"
                        />
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.city !== ""
                          ? orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.city
                          : "-"}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                city: !editState.city,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>電話番号</th>
                    {editState?.phoneNumber ? (
                      <div className="flex-ai-center">
                        <EditInfoInput
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"phoneNumber"}
                          updatedOrgProfile={updatedSupporter}
                          value={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.phoneNumber
                          }
                          mutationVariables={{}}
                          mutatinValiablesKey="phoneNumber"
                        />
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.phoneNumber !== ""
                          ? orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.phoneNumber
                          : "-"}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                phoneNumber: !editState.phoneNumber,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>代表者</th>
                    {editState?.representativeName ? (
                      <div className="flex-ai-center">
                        <EditInfoInput
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"representativeName"}
                          updatedOrgProfile={updatedSupporter}
                          value={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.representativeName
                          }
                          mutationVariables={{}}
                          mutatinValiablesKey="representativeName"
                        />
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.representativeName !== ""
                          ? orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.representativeName
                          : "-"}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                representativeName:
                                  !editState.representativeName,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>業種</th>
                    {editState?.industry ? (
                      <div>
                        <div className="flex-ai-center mb-1">
                          {/* <EditInfoInput
                                                                editState={editState}
                                                                setEditState={setEditState}
                                                                targetItem={"industry"}
                                                                updatedOrgProfile={updatedSupporter}
                                                                value={orgSupporter?.data?.allSupporters?.edges[0]?.node?.industry}
                                                                mutationVariables={{}}
                                                                mutatinValiablesKey="industry"
                                                            /> */}
                          <Button
                            className="ema__btn__update"
                            style={{ alignItems: "center", marginLeft: "0px" }}
                            onClick={async () => {
                              try {
                                await updatedSupporter({
                                  industry: selectedIndustry,
                                });
                              } catch (err) {
                                alert("正しい入力形式で入力してください");
                              }
                              setEditState({
                                ...editState,
                                industry: !editState.industry,
                              });
                            }}
                          >
                            <SyncIcon
                              fontSize="18px"
                              style={{ marginRight: 4 }}
                            />{" "}
                            更新
                          </Button>
                          <Button
                            style={{ padding: "0.3rem 8px" }}
                            onClick={() => {
                              setSelectedIndustry(
                                orgSupporter?.data?.allSupporters?.edges[0]
                                  ?.node?.industry
                              );
                              setEditState({
                                ...editState,
                                industry: !editState.industry,
                              });
                            }}
                          >
                            <CloseIcon fontSize="16px" className="pointer" />
                          </Button>
                        </div>
                        <div style={{ width: "300px" }}>
                          <Multiselect
                            dataKey="id"
                            textField="name"
                            value={selectedIndustry}
                            data={[
                              { name: "農業", id: "農業" },
                              { name: "林業", id: "林業" },
                              { name: "漁業", id: "漁業" },
                              { name: "鉱業", id: "鉱業" },
                              { name: "採石業", id: "採石業" },
                              { name: "砂利採取業", id: "砂利採取業" },
                              { name: "建設業", id: "建設業" },
                              { name: "製造業", id: "製造業" },
                              {
                                name: "電気・ガス・熱供給・水道業",
                                id: "電気・ガス・熱供給・水道業",
                              },
                              { name: "情報通信業", id: "情報通信業" },
                              { name: "運輸業", id: "運輸業" },
                              { name: "郵便業", id: "郵便業" },
                              { name: "卸売業", id: "卸売業" },
                              { name: "小売業", id: "小売業" },
                              { name: "金融業", id: "金融業" },
                              { name: "保険業", id: "保険業" },
                              { name: "不動産業", id: "不動産業" },
                              { name: "物品賃貸業", id: "物品賃貸業" },
                              { name: "学術研究", id: "学術研究" },
                              {
                                name: "専門・技術サービス業",
                                id: "専門・技術サービス業",
                              },
                              { name: "宿泊業", id: "宿泊業" },
                              { name: "飲食サービス業", id: "飲食サービス業" },
                              {
                                name: "生活関連サービス業",
                                id: "生活関連サービス業",
                              },
                              { name: "娯楽業", id: "娯楽業" },
                              { name: "教育", id: "教育" },
                              { name: "学習支援業", id: "学習支援業" },
                              { name: "医療", id: "医療" },
                              { name: "福祉", id: "福祉" },
                              {
                                name: "複合サービス事業",
                                id: "複合サービス事業",
                              },
                              {
                                name: "サービス業（他に分類されないもの）",
                                id: "サービス業（他に分類されないもの）",
                              },
                              { name: "公務", id: "公務" },
                              { name: "分類不能の産業", id: "分類不能の産業" },
                            ]}
                            onChange={(e) => {
                              setSelectedIndustry(e[1]?.name);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.industry !== ""
                          ? orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.industry
                          : "-"}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                industry: !editState.industry,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>売上規模</th>
                    {editState?.scaleLevel ? (
                      <div>
                        <div className="flex-ai-center mb-1">
                          <Button
                            className="ema__btn__update"
                            style={{ alignItems: "center", marginLeft: "0px" }}
                            onClick={async () => {
                              try {
                                await updatedSupporter({
                                  saleScale: selectedSaleScale.id,
                                });
                              } catch (err) {
                                alert("正しい入力形式で入力してください");
                              }
                              setEditState({
                                ...editState,
                                scaleLevel: !editState.scaleLevel,
                              });
                            }}
                          >
                            <SyncIcon
                              fontSize="18px"
                              style={{ marginRight: 4 }}
                            />{" "}
                            更新
                          </Button>
                          <Button
                            style={{ padding: "0.3rem 8px" }}
                            onClick={() => {
                              setSelectedSaleScale(
                                orgSupporter?.data?.allSupporters?.edges[0]
                                  ?.node?.saleScale?.scaleLevel
                              );
                              setEditState({
                                ...editState,
                                scaleLevel: !editState.scaleLevel,
                              });
                            }}
                          >
                            <CloseIcon fontSize="16px" className="pointer" />
                          </Button>
                        </div>
                        <div style={{ width: "300px" }}>
                          <Multiselect
                            dataKey="id"
                            textField="label"
                            value={selectedSaleScale}
                            data={allSaleScale?.data?.allSaleScale?.edges?.map(
                              (x) => x?.node
                            )}
                            onChange={(e) => {
                              console.log(e);
                              setSelectedSaleScale(e[1]);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.saleScale?.scaleLevel !== ""
                          ? orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.saleScale?.scaleLevel
                          : "-"}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                scaleLevel: !editState.scaleLevel,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>従業員数</th>
                    {editState?.stuffNumber ? (
                      <div className="flex-ai-center">
                        <EditInfoInput
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"stuffNumber"}
                          updatedOrgProfile={updatedSupporter}
                          value={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.stuffNumber
                          }
                          type="number"
                          mutationVariables={{}}
                          mutatinValiablesKey="stuffNumber"
                        />
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.stuffNumber !== ""
                          ? orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.stuffNumber
                          : "-"}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                stuffNumber: !editState.stuffNumber,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  {/* <tr>
                                            <th>海外拠点</th>
                                            {editState?.foreignBranch
                                                ?   <div>
                                                        <div className="flex-ai-center mb-1">
                                                            <Button
                                                                className="ema__btn__update"
                                                                style={{ alignItems: 'center', marginLeft: '0px' }}
                                                                onClick={ async () => {
                                                                    try {
                                                                        await updateM2m({
                                                                            variables: {
                                                                                overseasBranch: selectedOverseasBranch?.map((branch) => branch.id)
                                                                            },
                                                                        })
                                                                    } catch (err) {
                                                                        alert("正しい入力形式で入力してください")
                                                                    }
                                                                    setEditState({
                                                                        ...editState,
                                                                        foreignBranch: !editState.foreignBranch,
                                                                    })
                                                                }}
                                                            >
                                                                <SyncIcon
                                                                    fontSize="18px"
                                                                    style={{ marginRight: 4 }}
                                                                />
                                                                {" "}
                                                                更新
                                                            </Button>
                                                            <Button
                                                                style={{ padding: "0.3rem 8px" }}
                                                                onClick={() => {
                                                                    setSelectedOverseasBranch(orgSupporter?.data?.allSupporters?.edges[0]?.node?.overseasBranch?.edges?.map(branch => {
                                                                        return {
                                                                            id: branch?.node?.id,
                                                                            nameJp: branch?.node?.nameJp,
                                                                        }
                                                                    }))
                                                                    setEditState({
                                                                        ...editState,
                                                                        foreignBranch: !editState.foreignBranch,
                                                                    })
                                                                }}
                                                            >
                                                                <CloseIcon fontSize="16px" className="pointer" />
                                                            </Button>
                                                        </div>
                                                        <div style={{ width: '300px' }}>
                                                            <Multiselect
                                                                dataKey="id"
                                                                textField="nameJp"
                                                                defaultValue={selectedOverseasBranch}
                                                                data={foreignBranchCountries?.data?.allCountries?.edges?.map(country => {
                                                                    return { nameJp: country?.node?.nameJp, id: country?.node?.id}
                                                                })}
                                                                onChange={(e) => {
                                                                    setSelectedOverseasBranch(e)
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                :   <td style={{ display: 'flex', gap: '1rem' }}>
                                                        {orgSupporter?.data?.allSupporters?.edges[0]?.node?.overseasBranch?.edges?.length > 0
                                                            ?   <ol style={{ margin: '0px', padding: '0px', paddingLeft: '1rem', display: 'inline-block' }}>
                                                                    {orgSupporter?.data?.allSupporters?.edges[0]?.node?.overseasBranch?.edges?.map((branch, index) => {
                                                                        return <li key={index}>{branch?.node?.nameJp}</li>
                                                                    })}
                                                                </ol>
                                                            :   '-'
                                                        }
                                                        <span 
                                                            class="lnr lnr-pencil ema__color__blue pointer"
{...(publicView && {style: {display: "none"}})} 
                                                            onClick={() => {
                                                                setEditState({
                                                                    ...editState,
                                                                    foreignBranch: !editState.foreignBranch,
                                                                })
                                                            }}
                                                        />
                                                    </td>
                                            }
                                        </tr> */}
                  <tr>
                    <th style={{ display: "flex", alignItems: "center" }}>
                      <p style={{ margin: "auto 0px" }}>SDGs</p>
                    </th>
                    {editState?.sdgs ? (
                      <td style={{ width: "290px" }}>
                        <div className="flex-ai-center mb-1">
                          <Button
                            className="ema__btn__update"
                            style={{ alignItems: "center", marginLeft: "0px" }}
                            onClick={async () => {
                              try {
                                await updateSdges({
                                  variables: {
                                    focusedSdges: selectedSdgs?.map(
                                      (sdg) => sdg.node.id
                                    ),
                                  },
                                });
                              } catch (err) {
                                alert("正しい入力形式で入力してください");
                              }
                              setEditState({
                                ...editState,
                                sdgs: !editState.sdgs,
                              });
                            }}
                          >
                            <SyncIcon
                              fontSize="18px"
                              style={{ marginRight: 4 }}
                            />{" "}
                            更新
                          </Button>
                          <Button
                            style={{ padding: "0.3rem 8px" }}
                            onClick={() => {
                              setSelectedSdgs(
                                orgSupporter?.data?.allSupporters?.edges[0]
                                  ?.node?.focusedSdges?.edges
                              );
                              setEditState({
                                ...editState,
                                sdgs: !editState.sdgs,
                              });
                            }}
                          >
                            <CloseIcon fontSize="16px" className="pointer" />
                          </Button>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            flexWrap: "wrap",
                          }}
                        >
                          {sdgs?.data?.allSdgs?.edges?.map((sdg, index) => {
                            return (
                              <img
                                key={index}
                                src={sdg?.node?.logoUrl}
                                alt=""
                                className="profile-blur"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  opacity:
                                    selectedSdgs?.find(
                                      (selectedSdgs) =>
                                        selectedSdgs?.node?.id === sdg?.node?.id
                                    ) !== undefined
                                      ? "1"
                                      : "0.2",
                                }}
                                onClick={() => {
                                  const isAvailable = selectedSdgs?.findIndex(
                                    (selectedSdgs) =>
                                      selectedSdgs?.node?.id === sdg?.node?.id
                                  );
                                  if (isAvailable === -1)
                                    return setSelectedSdgs((prev) => {
                                      return [...prev, sdg];
                                    });
                                  const tempSelectedSdgs = selectedSdgs;
                                  tempSelectedSdgs.slice(isAvailable, 1);
                                  return setSelectedSdgs((prev) => {
                                    return prev.filter(
                                      (prev) => prev.node.id !== sdg.node.id
                                    );
                                  });
                                }}
                              />
                            );
                          })}
                        </div>
                      </td>
                    ) : (
                      <td
                        style={{
                          display: "flex",
                          gap: "1rem",
                          alignItems: "center",
                        }}
                      >
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.focusedSdges?.edges?.length > 0 ? (
                          <div style={{ display: "inline-block" }}>
                            {orgSupporter?.data?.allSupporters?.edges[0]?.node?.focusedSdges?.edges?.map(
                              (sdg, index) => {
                                return (
                                  <img
                                    key={index}
                                    src={sdg?.node?.logoUrl}
                                    alt=""
                                    className="profile-blur opacity-9"
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      marginLeft: index === 0 ? "0px" : "5px",
                                    }}
                                  />
                                );
                              }
                            )}
                          </div>
                        ) : (
                          "-"
                        )}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                sdgs: !editState.sdgs,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>組織HP</th>
                    {editState?.homepageUrl ? (
                      <div className="flex-ai-center">
                        <EditInfoInput
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"homepageUrl"}
                          updatedOrgProfile={updatedSupporter}
                          value={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.homepageUrl
                          }
                          mutationVariables={{}}
                          mutatinValiablesKey="homepageUrl"
                        />
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.homepageUrl !== "-" ? (
                          <a
                            href={
                              orgSupporter?.data?.allSupporters?.edges[0]?.node
                                ?.homepageUrl
                            }
                          >
                            <i class="pe-7s-home"> HPリンク</i>
                          </a>
                        ) : (
                          "-"
                        )}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                homepageUrl: !editState.homepageUrl,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>CSRウェブサイト</th>
                    {editState?.csrUrl ? (
                      <div className="flex-ai-center">
                        <EditInfoInput
                          editState={editState}
                          setEditState={setEditState}
                          targetItem={"csrUrl"}
                          updatedOrgProfile={updatedSupporter}
                          value={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.csrUrl
                          }
                          mutationVariables={{}}
                          mutatinValiablesKey="csrUrl"
                        />
                      </div>
                    ) : (
                      <td>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.csrUrl !== "-" ? (
                          <a
                            href={
                              orgSupporter?.data?.allSupporters?.edges[0]?.node
                                ?.csrUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i class="pe-7s-home"> </i>
                            <span
                              style={{
                                marginLeft: "8px",
                              }}
                            >
                              CSRウェブサイト
                            </span>
                          </a>
                        ) : (
                          "-"
                        )}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                csrUrl: !editState.csrUrl,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <th>SNS</th>
                    <td class="ema__sns">
                      {orgSupporter?.data?.allSupporters?.edges[0]?.node
                        ?.facebook ? (
                        <a
                          href={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.facebook
                          }
                        >
                          <img src={facebook_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={facebook_icon} style={iconStyleDisabled} />
                      )}
                      {orgSupporter?.data?.allSupporters?.edges[0]?.node
                        ?.line ? (
                        <a
                          href={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.line
                          }
                        >
                          <img src={line_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={line_icon} style={iconStyleDisabled} />
                      )}
                      {orgSupporter?.data?.allSupporters?.edges[0]?.node
                        ?.instagram ? (
                        <a
                          href={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.instagram
                          }
                        >
                          <img src={instagram_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={instagram_icon} style={iconStyleDisabled} />
                      )}
                      {orgSupporter?.data?.allSupporters?.edges[0]?.node
                        ?.youtube ? (
                        <a
                          href={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.youtube
                          }
                        >
                          <img src={youtube_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={youtube_icon} style={iconStyleDisabled} />
                      )}
                      {orgSupporter?.data?.allSupporters?.edges[0]?.node
                        ?.twitter ? (
                        <a
                          href={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.twitter
                          }
                        >
                          <img src={twitter_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={twitter_icon} style={iconStyleDisabled} />
                      )}
                      {orgSupporter?.data?.allSupporters?.edges[0]?.node
                        ?.tiktok ? (
                        <a
                          href={
                            orgSupporter?.data?.allSupporters?.edges[0]?.node
                              ?.tiktok
                          }
                        >
                          <img src={tiktok_icon} style={iconStyle} />
                        </a>
                      ) : (
                        <img src={tiktok_icon} style={iconStyleDisabled} />
                      )}
                    </td>
                    {editState.sns ? (
                      <>
                        {" "}
                        <Button
                          className="ema__btn__update"
                          onClick={async () => {
                            try {
                              await updateSupporter({
                                variables: {
                                  facebook,
                                  line,
                                  instagram,
                                  youtube,
                                  twitter,
                                  tiktok,
                                },
                              });
                            } catch (err) {
                              alert("正しい入力形式で入力してください");
                            }
                            setEditState({
                              ...editState,
                              sns: !editState.sns,
                            });
                          }}
                        >
                          <SyncIcon
                            fontSize="18px"
                            style={{ marginRight: 4 }}
                          />{" "}
                          更新
                        </Button>
                        <Button
                          style={{ padding: "0.3rem 8px" }}
                          onClick={() => {
                            setEditState({
                              ...editState,
                              sns: !editState.sns,
                            });
                          }}
                        >
                          <CloseIcon fontSize="16px" className="pointer" />
                        </Button>
                      </>
                    ) : (
                      <>
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            style={{
                              lineHeight: "22px",
                              marginLeft: 3,
                              ...(publicView && {
                                display: "none",
                              }),
                            }}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                sns: !editState.sns,
                              });
                            }}
                          />
                        )}
                      </>
                    )}
                  </tr>
                  {editState.sns ? (
                    <>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Facebook"
                            value={facebook}
                            onChange={(e) => {
                              setFacebook(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Line"
                            value={line}
                            onChange={(e) => {
                              setLine(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Instagram"
                            value={instagram}
                            onChange={(e) => {
                              setInstagram(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Youtube"
                            value={youtube}
                            onChange={(e) => {
                              setYoutube(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="Twitter"
                            value={twitter}
                            onChange={(e) => {
                              setTwitter(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td
                          style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Input
                            placeholder="TikTok"
                            value={tiktok}
                            onChange={(e) => {
                              setTiktok(e.target.value);
                            }}
                          />
                        </td>
                      </tr>
                    </>
                  ) : null}
                </tbody>
              </table>
            </Col>
            <Col sm="12" lg="6">
              <ActivityField
                offices={
                  orgSupporter?.data?.allSupporters?.edges[0]?.node
                    ?.officeAbroadForMap
                }
              />
              <table className="org_item_table_supporter mt-3">
                <tbody>
                  <tr>
                    <th
                      style={{
                        minWidth: "0px",
                        width: "max-content",
                        marginRight: "2rem",
                      }}
                    >
                      海外拠点
                    </th>
                    {editState?.foreignBranch ? (
                      <div>
                        <div className="flex-ai-center mb-1">
                          <Button
                            className="ema__btn__update"
                            style={{ alignItems: "center", marginLeft: "0px" }}
                            onClick={async () => {
                              try {
                                await updateM2m({
                                  variables: {
                                    overseasBranch: selectedOverseasBranch?.map(
                                      (branch) => branch.id
                                    ),
                                  },
                                });
                              } catch (err) {
                                alert("正しい入力形式で入力してください");
                              }
                              setEditState({
                                ...editState,
                                foreignBranch: !editState.foreignBranch,
                              });
                            }}
                          >
                            <SyncIcon
                              fontSize="18px"
                              style={{ marginRight: 4 }}
                            />{" "}
                            更新
                          </Button>
                          <Button
                            style={{ padding: "0.3rem 8px" }}
                            onClick={() => {
                              setSelectedOverseasBranch(
                                orgSupporter?.data?.allSupporters?.edges[0]?.node?.overseasBranch?.edges?.map(
                                  (branch) => {
                                    return {
                                      id: branch?.node?.id,
                                      nameJp: branch?.node?.nameJp,
                                    };
                                  }
                                )
                              );
                              setEditState({
                                ...editState,
                                foreignBranch: !editState.foreignBranch,
                              });
                            }}
                          >
                            <CloseIcon fontSize="16px" className="pointer" />
                          </Button>
                        </div>
                        <div style={{ width: "300px" }}>
                          <Multiselect
                            dataKey="id"
                            textField="nameJp"
                            defaultValue={selectedOverseasBranch}
                            data={foreignBranchCountries?.data?.countries?.edges?.map(
                              (country) => {
                                return {
                                  nameJp: country?.node?.nameJp,
                                  id: country?.node?.id,
                                };
                              }
                            )}
                            onChange={(e) => {
                              setSelectedOverseasBranch(e);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <td style={{ display: "flex", gap: "1rem" }}>
                        {orgSupporter?.data?.allSupporters?.edges[0]?.node
                          ?.overseasBranch?.edges?.length > 0 ? (
                          <ul
                            style={{
                              margin: "0px",
                              padding: "0px",
                              paddingLeft: "1rem",
                              display: "inline-block",
                            }}
                          >
                            {orgSupporter?.data?.allSupporters?.edges[0]?.node?.overseasBranch?.edges?.map(
                              (branch, index) => {
                                return (
                                  <li key={index}>{branch?.node?.nameJp}</li>
                                );
                              }
                            )}
                          </ul>
                        ) : (
                          "-"
                        )}
                        {canEdit && (
                          <span
                            class="lnr lnr-pencil ema__color__blue pointer"
                            {...(publicView && { style: { display: "none" } })}
                            onClick={() => {
                              setEditState({
                                ...editState,
                                foreignBranch: !editState.foreignBranch,
                              });
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </div>
      )}
    </Card>
  );
};

export default TabOrganizationOverview;
